import { skillLevelIds, skillLevelIdsOrder, skillLevels } from 'resources/skills/levels';

function isValidationValidated(userSkillValidation) {
  return userSkillValidation && userSkillValidation.validated; // For now, change it to userSkillValidation.validated when BE implements the flag
}

export function calculateLevel(userSkill) {
  if (!userSkill) return undefined;

  return skillLevels[userSkill.level] || skillLevels[skillLevelIds.beginner];
}

const initialCounts = skillLevelIdsOrder.reduce((result, levelId) => {
  result[levelId] = 0;
  return result;
}, {});

export function calculateValidationCountsBySkillLevelIds(userSkill) {
  if (!userSkill) return undefined;

  return (userSkill.validations || []).filter(isValidationValidated).reduce((
    result,
    validation
  ) => {
    const levelId = validation.level;
    result[levelId]++;
    return result;
  },
  { ...initialCounts });
}
